<template>
    <BreadCrumb PageTitle="Liste des inventaires" />
    <ListeInventaire />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeInventaire from "../../components/Inventaire/ListeInventraire.vue";

    export default defineComponent({
        name: "ListeInventairePage",
        components: {
            BreadCrumb,
            ListeInventaire,
        },
    });
</script>